import {
  FETCHING_JURIDICTIONAL_BREAKDOWN,
  FETCH_JURISDICTIONAL_BREAKDOWN_SUCCESS,
  FETCH_JURISDICTIONAL_BREAKDOWN_FAILED,
  RESET_JURISDICTIONAL_BREAKDOWN
} from './InvoiceDetailConstants';

const initialState = {
  invoiceDetail: null,
  fetchingJurisdictionalBreakdown: false,
  isLineAllocated: false
};

const InvoiceDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_JURIDICTIONAL_BREAKDOWN:
      return {
        ...state,
        fetchingJurisdictionalBreakdown: true
      };
    case FETCH_JURISDICTIONAL_BREAKDOWN_SUCCESS:
      return {
        ...state,
        fetchingJurisdictionalBreakdown: false,
        invoiceDetail: action.invoiceDetail,
        isLineAllocated: action.invoiceDetail.allocationJurisdictions ? true : false
      };
    case FETCH_JURISDICTIONAL_BREAKDOWN_FAILED:
      return {
        ...state,
        fetchingJurisdictionalBreakdown: false,
        invoiceDetail: null
      };
    case RESET_JURISDICTIONAL_BREAKDOWN:
      return { ...initialState };
    default:
      return state;
  }
};

export default InvoiceDetailReducer;



// WEBPACK FOOTER //
// ./src/redux/invoiceDetail/InvoiceDetailReducer.js